import { School } from '../school';
import { ClassType } from '../class-type';
import { Student } from '../student';
import { Reservation } from '../reservation';
import { Card } from '../card';
import { Location } from '../location';

export const enum LessonStatus {
    'OPEN',
    'EXECUTED',
    'CANCELLED'

}

export class Lesson {
    constructor(
        public id?: number,
        public begining?: any,
        public ending?: any,
        public maxParticipants?: number,
        public reservationCancellationPolicy?: number,
        public reminderPolicy?: number,
        public status?: LessonStatus,
        public minParticipants?: number,
        public school?: School,
        public classType?: ClassType,
        public teacher?: Student,
        public location?: Location,
        public free?: boolean,
        public videoConference?: boolean,
        public published?: boolean,
        public videoConferenceUrl?: string,
        public paymentIntentUrl?: string,
        public planningTag?: string,
        public bookings?: number,
        public availablePlaces?: number
    ) {
    }
}

export class LessonWithContextDetails extends Lesson {
    public currentStudentReservation: Reservation;
    public currentStudentCompatibleCards: Card[];

    /**
     * Converts a plain Lesson into LessonWithContextDetails
     */
    public static fromLesson(lesson: Lesson): LessonWithContextDetails {
        const enriched = new LessonWithContextDetails(
            lesson.id,
            lesson.begining,
            lesson.ending,
            lesson.maxParticipants,
            lesson.reservationCancellationPolicy,
            lesson.reminderPolicy,
            lesson.status,
            lesson.minParticipants,
            lesson.school,
            lesson.classType,
            lesson.teacher,
            lesson.location,
            lesson.free,
            lesson.videoConference,
            lesson.published,
            lesson.videoConferenceUrl,
            lesson.paymentIntentUrl,
            lesson.planningTag,
            lesson.bookings,
            lesson.availablePlaces
        );

        enriched.currentStudentCompatibleCards = [];
        enriched.currentStudentReservation = null;

        return enriched;
    }
}

export class LessonAvailability {
    constructor(public lessonId?: number, public availablePlaces?: number) {

    }
}

export class LessonBulkCreateInput {
    constructor(
        public lesson: Lesson,
        public toDate: any,
        public createInUnavailableDates: boolean,
        public createInMondays: boolean,
        public createInTuesdays: boolean,
        public createInWednesdays: boolean,
        public createInThursdays: boolean,
        public createInFridays: boolean,
        public createInSaturdays: boolean,
        public createInSundays: boolean
    ) {
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/lesson/lesson.model.ts